import React from 'react';
const TermsPage = () => {
  return <div className="bg-white" data-id="element-1864">
      <div className="container mx-auto px-4 py-12" data-id="element-1865">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1866">
          Terms & Conditions
        </h1>
        <p className="mb-6" data-id="element-1867">
          <span className="text-burgundy-600" data-id="element-1868">N</span>orthampton{' '}
          <span className="text-burgundy-600" data-id="element-1869">D</span>riving{' '}
          <span className="text-burgundy-600" data-id="element-1870">S</span>chool – Learner Driver
          Terms & Conditions
        </p>
        <p className="mb-6" data-id="element-1871">
          By booking or attending lessons with Northampton Driving School, you
          agree to the following terms:
        </p>
        <section className="mb-8" data-id="element-1872">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1873">
            1. Eligibility
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1874">
            <li data-id="element-1875">
              You must hold a valid UK provisional or full driving licence
              recognised in the UK.
            </li>
            <li data-id="element-1876">
              You must show your licence to your instructor at your first lesson
              and whenever asked.
            </li>
            <li data-id="element-1877">
              Any penalty points, endorsements, or medical restrictions must be
              declared.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1878">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1879">
            2. Bookings & Payments
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1880">
            <li data-id="element-1881">
              Lessons must be booked through the school or directly with your
              instructor.
            </li>
            <li data-id="element-1882">
              Payment is required in advance to confirm bookings (individual
              lessons or block bookings).
            </li>
            <li data-id="element-1883">
              Block booking discounts apply only when full payment is made in
              advance.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1884">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1885">
            3. Attendance
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1886">
            <li data-id="element-1887">
              Your instructor will wait at the agreed pick-up point for up to 15
              minutes. If you do not attend, the lesson will be charged in full.
            </li>
            <li data-id="element-1888">All pick-up and drop-off points must be pre-agreed.</li>
            <li data-id="element-1889">
              If using your own car, it must be roadworthy, taxed, MOT'd, and
              insured for learner use. Proof of insurance must be shown each
              lesson.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1890">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1891">
            4. Lesson Conduct
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1892">
            <li data-id="element-1893">
              Pupils must follow the instructor's instructions at all times.
            </li>
            <li data-id="element-1894">
              Aggressive, unsafe, or abusive behaviour will result in immediate
              termination of lessons without refund.
            </li>
            <li data-id="element-1895">
              Pupils must wear suitable footwear (no flip-flops, high heels, or
              unsafe shoes).
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1896">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1897">
            5. Fitness to Drive
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1898">
            <li data-id="element-1899">
              You must not be under the influence of alcohol, drugs, or
              medication that affects driving.
            </li>
            <li data-id="element-1900">
              Lessons will be stopped if your instructor deems you unfit to
              drive, and the full lesson fee will still apply.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1901">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1902">
            6. Driving Tests
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1903">
            <li data-id="element-1904">
              Instructors will only take pupils to a test if they are judged
              "test ready".
            </li>
            <li data-id="element-1905">
              Use of the tuition car for a DVSA driving test is at the
              instructor's discretion.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1906">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1907">
            7. Liability
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1908">
            <li data-id="element-1909">Our vehicles are insured and maintained to a safe standard.</li>
            <li data-id="element-1910">
              Northampton Driving School is not liable for DVSA test
              cancellations, delays, fines, or penalties incurred by pupils.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1911">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1912">
            8. Prices & Changes
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1913">
            <li data-id="element-1914">
              Prices may change at any time, but prior notice will be given
              where possible.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1915">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1916">
            9. Complaints
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1917">
            <li data-id="element-1918">
              Please first raise any concerns directly with your instructor.
            </li>
            <li data-id="element-1919">
              If unresolved, email info@northamptondrivingschool.co.uk. We aim
              to reply within 14 days.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1920">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1921">
            10. Governing Law
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1922">
            <li data-id="element-1923">These Terms are governed by the laws of England and Wales.</li>
          </ul>
        </section>
      </div>
    </div>;
};
export default TermsPage;